import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { MBTextBody1 } from '@shared/components/typography';
import { TodoField } from '@shared/data/entity/fields/TodoField';
import { grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: TodoField;
  style: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

const todoStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function TodoCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[todoStyles, style]}>
      <MBTextBody1 style={textStyle}>
        {i18n('card.blocks.todo.summary', {
          completedCount: field.todos.filter(item => item.status === 'COMPLETED').length,
          count: field.todos.length,
        })}
      </MBTextBody1>
    </CardCollectionViewFieldContainer>
  );
}
